// extracted by mini-css-extract-plugin
export var active = "_f7-7";
export var blink = "_f7-8";
export var dropDownSelector = "_f7-4";
export var dropDownWrapper = "_f7-3";
export var fakeCursor = "_f7-6";
export var fontSizeButton = "_f7-9";
export var formQuillEditor = "_f7-0";
export var pressed = "_f7-a";
export var qlBlank = "_f7-1";
export var textFormattingToolbar = "_f7-2";
export var textToolbarOption = "_f7-5";